<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">


            <el-form-item label="平台">
                <el-select v-model="formInline.platformId"  placeholder="平台" >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="formInline.itemType"  placeholder="类型" >
                    <el-option v-for="item in itemTypeData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品名称">
                <el-input v-model="formInline.itemName" placeholder="输入单品、促销、套装、活动查询"></el-input>
            </el-form-item>
            <el-form-item label="是否参与推广">
                <el-select v-model="formInline.isDistribution"  placeholder="是否参与推广" >
                    <el-option v-for="item in statusData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>

        </el-form-item>
        <el-form-item>
            <el-button type="success" @click="init">初始化</el-button>
            <el-button type="primary" @click="batchSet">批量设置</el-button>
        </el-form-item>
        </el-form>


        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="70"></el-table-column>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformId" label="平台" :formatter="platformShow" width="100"></el-table-column>
                <el-table-column prop="itemImage" label="图" width="100">
                    <template slot-scope="scope">
                        <img :src="scope.row.itemImage" width="70" height="70"/>
                    </template>
                </el-table-column>
                <el-table-column prop="itemName" label="商品名称"  ></el-table-column>
                <el-table-column prop="itemType" label="商品类型"   width="100" :formatter="itemTypeShow"></el-table-column>
                <el-table-column prop="price" label="金额"   width="100"></el-table-column>
                <el-table-column prop="isDistribution" label="是否参与推广" :formatter="statusShow" width="100"></el-table-column>
                <!--<el-table-column prop="percentage" label="默认佣金比例"   width="150"></el-table-column>-->
            <el-table-column prop="percentageType" label="是否自定义" :formatter="statusShow" width="100"></el-table-column>
                <el-table-column prop="remark" label="佣金比例"  align="left" >
                    <template slot-scope="scope">
                        <p style="text-align: left"  v-html="scope.row.remark"></p>
                    </template>
                </el-table-column>

                <el-table-column prop="updateTime" label="更新日期"   width="150"></el-table-column>
                <el-table-column prop="operator" label="操作人"   width="120"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">设置</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="设置商品佣金" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="110px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="推广">
                    <el-radio v-model="form.isDistribution" :label="1">参与</el-radio>
                    <el-radio v-model="form.isDistribution" :label="0">不参与</el-radio>
                </el-form-item>
                <el-form-item label="佣金" :hidden="form.isDistribution==0">
                    <el-radio v-model="form.percentageType" :label="0">统一佣金比例</el-radio>
                    <el-radio v-model="form.percentageType" :label="1">自定义佣金比例</el-radio>
                </el-form-item>


                <el-form-item label="统一佣金比例" :hidden="form.percentageType==1||form.isDistribution==0">
                    <!--<template slot-scope="scope">-->
                    <el-input-number v-model="form.percentage" :precision="2" :step="0.05" :min="0" :max="1" label="分成比例"></el-input-number>
                    <!--</template>-->
                </el-form-item>

                <el-form-item label="自定义佣金比例"  :hidden="form.percentageType==0||form.isDistribution==0">
                    <el-table :data="form.detailEntity" v-loading="loading" >
                        <el-table-column type="index" label="序号" width="70"></el-table-column>

                        <el-table-column prop="groupName" label="分组"   ></el-table-column>
                        <el-table-column prop="percentage" label="比例"  >
                            <template slot-scope="scope">
                                <el-input-number v-model="scope.row.percentage" :precision="2" :step="0.05" :min="0" :max="1" label="分成比例"></el-input-number>
                            </template>
                        </el-table-column>

                    </el-table>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getPlatformList,getDistributorItemList,saveDistributorItem,getSingleDistributorItem,initDistributorItem} from '../../api/api';
    import uploadComponents from '@/components/upload';

    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                itemTypeData:[{"id":4,"name":"单品"},{"id":2,"name":"套装"},{"id":1,"name":"促销"},{"id":5,"name":"活动"}],
                statusData:[{"id":null,"name":"全部"},{"id":0,"name":"否"},{"id":1,"name":"是"}],
                loading:true,
                dialogFormVisible:false,
                form:{"id":null,"groupName":""},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    itemType:4,
                    isDistribution:null,
                    platformId:1,
                },
                platformDisabled:false,
                multipleSelection:[],

            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList(this.formInline).then((res) => {
                this.platformData=res.data;
                this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });
        },
        components:{
            uploadComponents
        },
        methods:{
            //定义查询方法
            getList(){
                getDistributorItemList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;

                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            init(){

                if(confirm("确定初始化吗？")) {
                    initDistributorItem().then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }
            },

            handleAdd(){
                //var d={id:0};
                this.dialogFormVisible = true;
                this.form.id=null;
                this.form.groupName='';

            },
            batchSet(){

                if(this.multipleSelection.length<=0){
                    this.$message({
                        showClose: true,
                        message: "请选择行再批量设置",
                        type: 'error'
                    });
                    return;
                }
                var data={"id":0};
                this.handleEdit(data);
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                getSingleDistributorItem({id:data.id}).then((res) => {
                    //console.log(res.data);
                    if(res.data.value!=undefined) {
                        this.form = res.data.value;
                        if(this.form.platformId==null){
                            this.form.platformId=1;
                        }
                    }
                });
            },

            save(data){
                console.log(data);
                console.log(this.multipleSelection);
                if(data.isDistribution==1&&data.percentageType==0&&data.percentage==0){
                    this.$message({
                        showClose: true,
                        message: "请输入分成比例",
                        type: 'error'
                    });
                    return;
                }
                var selectDatas=[];//选择的数据
                var savedatas=[];//保存的数据
                if(data.id==null||data.id==0){
                    selectDatas=this.multipleSelection;
                }else{
                    selectDatas.push({"id":data.id,"createTime":data.createTime,"platformId":data.platformId});
                }
                for (var value of selectDatas) {
                    var d=JSON.parse(JSON.stringify(data));
                    d.id=value.id;
                    d.createTime=value.createTime;
                    d.platformId=value.platformId;
                    console.log(d);
                    savedatas.push(d);
                }

                console.log(savedatas);
                var param={entities:JSON.stringify(savedatas)};
                //console.log(param);
                saveDistributorItem(param).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },
            itemTypeShow(row, column, cellValue) {
                for(var key in this.itemTypeData){
                    if(this.itemTypeData[key].id==cellValue) {
                        return this.itemTypeData[key].name;
                    }
                }
                //return this.randData.name;

            },
            statusShow(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
                //return this.randData.name;

            },
            platformShow(row,column,cellValue){
                for(var key in this.platformData){
                    if(this.platformData[key].platformId==cellValue) {
                        return this.platformData[key].platformName;
                    }
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }


        }
    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/distributorItem.vue